import { Constants } from "src/app/_consts/constants";
import { SConstants } from "../const/s-constants";
import { SObject } from "./s-object";

export interface ISGroup {
    id_group: number
    name: string
}

export class SGroup extends SObject implements ISGroup {
    id_group: number;
    name: string;

    public static PRIMARY_KEY = "id_group"
    public static COLS = Constants.GROUPS_COLS

    constructor(json: object) {
        super(json, true)
    }

    public static fromArray(array: any[]) {
        for (let i = 0; i < array.length; i++) {
            array[i] = new SGroup(array[i])

        }
        return array
    }
}
